import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useState, useEffect, useContext, useMemo} from 'react';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors, TF} from '../../constants/Common';
import FilteredUnit from '../../constants/FilteredUnit';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {sortYearOptions} from '../../pages/orgManager/Utils/InfraStructureProfile/constant/sorYear';
import yearFilterArray from '../../shared/YearFilterArray';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useUserStore from '../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import {MYConfig, MYData} from '../MonthlyYearly/Interface/common';
import MonthlyYearlyDrawerForm from '../MonthlyYearly/MonthlyYearlyDrawerForm';

import {facilityKeyLabel, yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {OAKey, OALabel} from './Constants/IP/OtherActivityKeyLabel';

const OtherActivityForm: React.FC<{currentStep?: number}> = ({currentStep}) => {
  const isCompanyUserOrAdmin =
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user);
  const {getFieldValue, setFields} = useFormInstance();
  const facilityDetails = useCompanyStore.getState().facilityDetails;
  const [formSelectedCountry, setFormSelectedCountry] = useState<string>('');
  const [facilityOpt, setFacilityOpt] = useState<any[]>([]);
  const userDetails = useUserStore.getState().userDetails;

  const {facilityId, selectedYear, selectedCountry} = useContext(
    SelectedCountryContext
  );

  useEffect(() => {
    setYearOptions(
      yearFilterArray(
        facilityDetails,
        !isCompanyUserOrAdmin ? userDetails?.facility : undefined,
        false
      )
    );
  }, []);

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
  }, []);

  useEffect(() => {
    setFormSelectedCountry(
      facilityOpt?.find((item: any) => {
        return (
          item?._id === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
        );
      })?.country
    );
  }, [facilityOpt]);

  const [yearOptions, setYearOptions] = useState<any[]>([]);

  useEffect(() => {
    setYearOptions(
      yearFilterArray(
        facilityDetails,
        !isCompanyUserOrAdmin ? userDetails?.facility : undefined,
        false
      )
    );
  }, []);

  const monYear: MYConfig[] = useMemo(() => {
    return [
      {
        mainTitle: {key: OAKey.tDLosses_TF, title: OALabel.tDLosses_TF},
        unit: '%',
        isPercent: true
      },
      {
        mainTitle: {key: OAKey.electricSold_TF, title: OALabel.electricSold_TF},
        unit: FilteredUnit(formSelectedCountry ?? selectedCountry).electricity
      }
    ];
  }, [formSelectedCountry, selectedCountry]);

  return (
    <>
      {currentStep === 0 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              initialValue={selectedYear}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={sortYearOptions(yearOptions)}
                suffixIcon={<YearCalender />}
                disabled={getFieldValue('_id') !== undefined}
                onChange={(e) => {
                  setFacilityOpt(
                    facilityDetails?.[e]?.filter((item: any) => {
                      return !item.leased;
                    }) ?? []
                  );
                  if (getFieldValue(facilityKeyLabel.key)) {
                    setFields([
                      {
                        name: facilityKeyLabel.key,
                        value: undefined,
                        errors: ['Please select facility again']
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {isCompanyUserOrAdmin && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={facilityKeyLabel.key}
                  label={facilityKeyLabel.label}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(facilityKeyLabel.label)
                    }
                  ]}
                  initialValue={facilityId}
                >
                  <Select
                    placeholder={`Choose ${facilityKeyLabel.label}`}
                    options={
                      facilityOpt?.map((item: any) => {
                        return {label: item.name, value: item._id};
                      }) ?? []
                    }
                    disabled={getFieldValue('_id') !== undefined}
                    onChange={(e) => {
                      setFormSelectedCountry(
                        facilityDetails?.[
                          getFieldValue(yearKeyLabel.key) ?? ''
                        ]?.find((item: any) => {
                          return item._id === e;
                        })?.country
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
      {currentStep === 1 && (
        <MonthlyYearlyDrawerForm
          config={monYear}
          data={getFieldValue(TF) as MYData[]}
        />
      )}
    </>
  );
};

export default OtherActivityForm;
